<template>
    <v-card style="padding: 24px; text-align: justify;">
      {{content}} 
    </v-card>
</template>

<script>
import axios from '@/plugins/AxiosExtension';
/* import * as Text from "TextComponent-vue"
var TextComponent= Text.TextComponent */

export default {
  /*components: {
        'TextComponent-vue': Text
    },*/
    props: ["content"],

  
  data() {
      return {
        Text: null
        //url: 'https://terryz.github.io/video/movie.mp4'
      };
  },
  mounted() {
  }
};
</script>

<style scoped>
div {
  font-size: 1.2rem;
}
</style>
